import jquery from 'jquery';
import Swal from 'sweetalert2';

window.$ = window.jquery = window.jQuery = jquery;

// plugins
require('bootstrap');
require('datatables.net')(window, jquery);
require('datatables.net-bs4')(window, jquery);
require('datatables.net-select-dt')(window, jquery);
require('../plugins/select2/js/select2.full')(window, jquery);
require('jquery-validation');

require('chart.js');
require('../plugins/tabletojson/tabletojson.min.js');
require('../plugins/image-uploader/dist/image-uploader.min.js');

window.Swal = Swal;
export default jquery;
